export const OTP_TOKEN = 'OTP-TOKEN';
export const ID_TOKEN = 'ID_TOKEN';
export const OTP_REDIRECT_TO = 'OTP_REDIRECT_TO';
